import { Grid } from '@mui/material';
import { FastField } from 'formik';

import { IFormFieldConfig } from '@shared/components/FormFieldsConstructor';
import { FieldWrapper, FormContainer, FormControl, FormWrapper } from '@styles/StyledDiv';
import { IAmorizationDetailer, ICalculatorFormProps, IntrestRateCalc, } from '../interfaces';

export const CalculatorForm = ({ formConfig, children }: ICalculatorFormProps) => {
  const renderFields = (fieldsList: IFormFieldConfig<IntrestRateCalc | IAmorizationDetailer>[]) => {
    return fieldsList?.map(({ name, label, component: Component, ...rest }) => (
      <FormControl key={name}>
        {label}
        <FieldWrapper>
          <FastField {...rest} name={name} component={Component} />
        </FieldWrapper>
      </FormControl>
    ));
  };

  return (
    <>
      <FormContainer>
        <FormWrapper>
          <Grid container spacing={12}>
            <Grid item md={12}>
              {renderFields(formConfig)}
            </Grid>
          </Grid>
          {children}
        </FormWrapper>
      </FormContainer>
    </>
  );
};

